import { render, staticRenderFns } from "./LoginShareToken.vue?vue&type=template&id=4227f630&scoped=true&"
import script from "./LoginShareToken.vue?vue&type=script&lang=js&"
export * from "./LoginShareToken.vue?vue&type=script&lang=js&"
import style0 from "./LoginShareToken.vue?vue&type=style&index=0&id=4227f630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227f630",
  null
  
)

export default component.exports